import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Table } from 'antd';
import moment from 'moment';
import Link from '../components/general/Link';
import NewRetainerClientAssignmentForm from '../forms/NewRetainerClientAssignmentForm';
import NewRetainerClientDocUploadRequestForm from '../forms/NewRetainerClientDocUploadRequestForm';
import NewRetainerClientAssignmentActivityForm from '../forms/NewRetainerClientAssignmentActivityForm';
import RetainerClientDocumentUpload from '../components/RetainerClientDocumentUpload';
import RetainerClientCreateContactForm from '../forms/RetainerClientCreateContactForm';

const { Column } = Table;

class ClientDashboardPage extends Component {
  state = {
    activityAssignmentId: null,
  };

  closeAssignmentActivityModal = () => {
    this.setState({
      activityAssignmentId: null,
    });
  };

  render() {
    const { retainerClient, match } = this.props;
    const { activityAssignmentId } = this.state;
    return (
      <div>
        <NewRetainerClientAssignmentActivityForm
          retainerClientAssignmentId={activityAssignmentId}
          closeModal={this.closeAssignmentActivityModal}
        />
        <div style={{ marginBottom: 20 }}>
          <Link to={`${match.url}/meetings/create`}>
            <Button htmlType="button">New Minutes of Meeting</Button>
          </Link>
        </div>
        <div className="contentBox" style={{ marginBottom: 20 }}>
          <h3>Ongoing Assignments</h3>
          <Table
            dataSource={retainerClient.assignments.filter(
              (entry) => !entry.endDate && entry.approvalStatus === 'accepted',
            )}
            rowKey="id"
          >
            <Column title="Title" dataIndex="title" key="title" />
            <Column
              title="Created On"
              dataIndex="createdAt"
              key="createdAt"
              render={(text) => moment(new Date(text)).format('Do MMM, YYYY')}
            />
            <Column
              title="Start Date"
              dataIndex="startDate"
              key="startDate"
              render={(text) => moment(text, 'YYYY-MM-DD').format('Do MMM, YYYY')}
            />
            <Column
              title="Proposed Due Date"
              key="dueDate"
              render={(text, record) =>
                moment(record.startDate, 'YYYY-MM-DD')
                  .add(record.proposedDurationDays, 'days')
                  .format('Do MMM, YYYY')
              }
            />
            <Column
              title="Status"
              key="status"
              render={(text, record) => {
                const delayDays = Math.round(
                  moment().diff(
                    moment(record.startDate, 'YYYY-MM-DD').add(record.proposedDurationDays, 'days'),
                    'days',
                    true,
                  ),
                );
                if (delayDays <= 0) {
                  return <p style={{ color: 'green' }}>{Math.abs(delayDays)} days remaining</p>;
                }
                return <p style={{ color: 'red' }}>{Math.abs(delayDays)} days overdue</p>;
              }}
            />
            <Column
              title="Actions"
              key="actions"
              render={(text, record) => (
                <div>
                  <Button htmlType="button" onClick={() => this.setState({ activityAssignmentId: record.id })}>
                    New activity
                  </Button>
                  <Link to={`${match.url}/assignment/${record.id}/discussions`}>
                    <Button htmlType="button">Discussion Group</Button>
                  </Link>
                  <Button htmlType="button">Mark as completed</Button>
                </div>
              )}
            />
          </Table>
        </div>
        <div className="contentBox" style={{ marginBottom: 20 }}>
          <h3>New Assignments (pending client approval)</h3>
          <Table
            dataSource={retainerClient.assignments.filter((entry) => !entry.endDate && entry.approvalStatus === 'open')}
            rowKey="id"
          >
            <Column title="Title" dataIndex="title" key="title" />
            <Column title="Description" dataIndex="description" key="description" />
            <Column
              title="Proposed no. of days to complete"
              key="proposedDurationDays"
              dataIndex="proposedDurationDays"
              render={(text) => `${text} days`}
            />
            <Column
              title="Created On"
              key="createdAt"
              dataIndex="createdAt"
              render={(text) => moment(new Date(text)).format('Do MMM, YYYY')}
            />
            <Column
              title="Approval Pending for"
              key="pendingDays"
              render={(text, record) =>
                `${Math.round(moment().diff(moment(new Date(record.createdAt)), 'days', true))} days`
              }
            />
          </Table>
        </div>

        <div className="contentBox" style={{ marginBottom: 20 }}>
          <h3>New Minutes (pending client approval)</h3>
          <Table dataSource={retainerClient.meetings.filter((entry) => entry.approvalStatus === 'open')} rowKey="id">
            <Column
              title="Date"
              key="date"
              dataIndex="date"
              render={(text) => moment(text, 'YYYY-MM-DD').format('Do MMM, YYYY')}
            />
            <Column title="Agenda" dataIndex="agenda" key="agenda" />
            <Column title="Conclusion" dataIndex="conclusion" key="conclusion" />
            <Column
              title="Approval Pending for"
              key="pendingDays"
              render={(text, record) =>
                `${Math.round(moment().diff(moment(new Date(record.createdAt)), 'days', true))} days`
              }
            />
          </Table>
        </div>

        <div className="contentBox" style={{ marginBottom: 20 }}>
          <h3>Open document upload requests</h3>
          <Table
            dataSource={retainerClient.documents.filter((entry) => !entry.uploaded && entry.uploadRequestCreatedAt)}
            rowKey="id"
          >
            <Column title="Title" dataIndex="title" key="title" />
            <Column title="Description" dataIndex="description" key="description" />
            <Column
              title="Request Date"
              key="uploadRequestCreatedAt"
              dataIndex="uploadRequestCreatedAt"
              render={(text) => moment(new Date(text)).format('Do MMM, YYYY')}
            />
            <Column
              title="Delay in uploading"
              key="delayDays"
              render={(text, record) =>
                `${Math.round(moment().diff(moment(new Date(record.uploadRequestCreatedAt)), 'days', true))} days`
              }
            />
          </Table>
        </div>

        <div className="contentBox" style={{ marginBottom: 20 }}>
          <Row gutter={25}>
            <Col span={8}>
              <h3>Create new assignment</h3>
              <NewRetainerClientAssignmentForm retainerClientId={retainerClient.id} />
            </Col>
            <Col span={8}>
              <h3>Create new document upload request</h3>
              <NewRetainerClientDocUploadRequestForm retainerClientId={retainerClient.id} />
            </Col>
            <Col span={8}>
              <h3>Upload document</h3>
              <RetainerClientDocumentUpload retainerClientId={retainerClient.id} />
            </Col>
          </Row>
        </div>

        <div className="contentBox">
          <Row gutter={25}>
            <Col span={8}>
              <h3>Add new contact</h3>
              <RetainerClientCreateContactForm retainerClientId={retainerClient.id} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

ClientDashboardPage.propTypes = {
  retainerClient: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default ClientDashboardPage;



// WEBPACK FOOTER //
// ./src/pages/ClientDashboardPage.jsx